import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalInfo, MoveTo, SourceMoveTo, WsProjectInfo } from 'src/app/models';


@Component({
    selector: 'app-restore-modal',
    templateUrl: './restore-modal.component.html',
    styleUrls: ['./restore-modal.component.scss'],
    standalone: false
})
export class RestoreModalComponent implements OnInit {

  @Input() data: ModalInfo;
  @Output() restore: EventEmitter<ModalInfo> = new EventEmitter();
  destination: MoveTo;
  source: SourceMoveTo;
  submitted:boolean = false;
  invalid:boolean = false;
  disabledButton:boolean = true;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.data) {
      this.source = {
        data: this.data as unknown as WsProjectInfo,
        id_parent: this.data.id_parent,
      };


        if (this.data.type !== 'workspace') {
          this.destination = {
            id_entity: this.data.id,
            type: this.data.type,
            new_parent: this.data.id_parent,
            parent_type: this.data.type_parent
          };
          this.disabledButton = true;
        }else{
          this.disabledButton = false;
        }
        this.invalid = false;
      
    }
  }



  /**
   * Metodh to pass data to restore item to favourites-section component. 
   * Send the result of the modal to the parent component
   */

  async restoreItem() {
    this.submitted = true;
    const extraFieldIsValid = this.data.type === 'workspace' || (this.data.type !== 'workspace' && !!this.destination) ;
    if ( !extraFieldIsValid) {
      this.invalid = !extraFieldIsValid;
      return;
    }

    if(this.data.type !== 'workspace')
    {
      this.data.id_parent = this.destination.new_parent;
      this.data.type_parent = this.destination.parent_type;
    }
    this.restore.emit(this.data);    
    this.activeModal.close();
  }

  
  /**
   * Get the target of the move to from the child component
   * @param $event Destination
   */

  handleDestination($event: MoveTo) {
    this.destination = $event;
    this.disabledButton = false;
  }


  /**
   * Close modal
   */

  onClose() {
    this.activeModal.close();
  }
}
